import React from "react";
import {observer} from "mobx-react";
import {useViewController} from "data/services/locator";
import {Bindings} from "data/constants/bindings";
import {type ITeamSavedModalController} from "views/components/modals/team_saved_modal/team_saved_modal.controller";
import {Modal, styled} from "@mui/material";
import {ModalType} from "data/enums";
import {get, eq, includes} from "lodash";
import {PrimaryButton, PrimaryButtonInvert} from "views/components/style";
import {
	ModalBox,
	ModalContent,
	ModalHeader,
	ModalBody,
	ModalTitle,
	ModalText,
	CloseBtn,
	ModalFooter,
} from "views/components/modals/common/common.component";
import {ReactComponent as IconCheckMark} from "assets/img/icon/icon-checkmark.svg";
import {ReactComponent as IconClose} from "assets/img/icon/close.svg";
import {Exist} from "views/components/exist/exist.component";

const TeamSavedModalFooter = styled(ModalFooter)`
	display: flex;
	flex-direction: row;
	justify-content: center;

	margin-top: 10px;
`;

export const TeamSavedModal: React.FC = observer(() => {
	const {i18n, visibleModal, modalContent, close, selectedRoundIndex, toNextRound} =
		useViewController<ITeamSavedModalController>(Bindings.TeamSavedModalController);

	const title = get(modalContent, "title", "");
	const message = get(modalContent, "message", "");

	const showPrompt = eq(ModalType.TEAM_SAVED, visibleModal);
	const isNextRoundEnable = includes([0, 1], selectedRoundIndex);

	if (!showPrompt) {
		return null;
	}

	return (
		<Modal open={showPrompt}>
			<ModalBox>
				<ModalContent>
					<ModalHeader>
						<IconCheckMark />
					</ModalHeader>
					<ModalBody>
						<ModalTitle style={{marginBottom: 25, marginTop: 15}}>{title}</ModalTitle>
						<ModalText>{message}</ModalText>
					</ModalBody>
					<CloseBtn onClick={close}>
						<IconClose />
					</CloseBtn>
					<TeamSavedModalFooter>
						<PrimaryButtonInvert onClick={close} size="large">
							{i18n.t("modal.team_saved.stay_button", "Back To My Team")}
						</PrimaryButtonInvert>
						<Exist when={isNextRoundEnable}>
							<PrimaryButton onClick={toNextRound} size="large">
								{i18n.t("modal.team_saved.next_day_button", "Team for Day")}{" "}
								{selectedRoundIndex + 2}
							</PrimaryButton>
						</Exist>
					</TeamSavedModalFooter>
				</ModalContent>
			</ModalBox>
		</Modal>
	);
});
